import React from "react";
import cn from "classnames";
import styles from "./styles.css";

const Input = React.forwardRef((props, ref) => {
  const { className, ...rest } = props;

  return (
    <input
      {...rest}
      ref={ref}
      className={cn(styles.input, className)}
      type="search"
      autoCapitalize="none"
      autoComplete="off"
      autoCorrect="off"
      spellCheck="false"
      required
    />
  );
});

Input.defaultProps = {
  placeholder: "Search Lonely Planet",
};

export default Input;
